import React from "react";
import { Link } from "react-router-dom";
import { FaFacebook, FaInstagram, FaTiktok } from "react-icons/fa";
import { SiGoodreads } from "react-icons/si";
import { db } from "../firebase";
import { doc, onSnapshot } from "firebase/firestore";
import toast from "react-hot-toast";
import "./Footer.css";

export default function Footer({ generalConfig }) {
    const config = {
        footerDescription: `Bold stories for bold readers.\nBy ${generalConfig?.authorName || "Liliz Black"} from San Juan, Puerto Rico.`,
        facebookUrl: "https://facebook.com/LBLilizBlack",
        instagramUrl: "https://instagram.com/lilizblack/",
        tiktokUrl: "https://tiktok.com/@liliz.black",
        goodreadsUrl: "https://www.goodreads.com/author/show/21626021.Liliz_Black",
        socialTitle: `Follow ${generalConfig?.authorName || "Liliz Black"}`,
        footerNote: "",
        categories: [],
        mailerLiteApiKey: "",
        mailerLiteGroupId: "",
        ...generalConfig
    };
    const [email, setEmail] = React.useState("");
    const [subscribing, setSubscribing] = React.useState(false);



    async function handleSubscribe(e) {
        e.preventDefault();
        if (!email) return;
        if (!config.mailerLiteApiKey || !config.mailerLiteGroupId) {
            toast.error("Newsletter is not configured.");
            return;
        }

        setSubscribing(true);
        try {
            // NOTE: Calling MailerLite directly from frontend exposes the API Key.
            // For a production site with high traffic, use a backend function.
            const response = await fetch(`https://api.mailerlite.com/api/v2/groups/${config.mailerLiteGroupId}/subscribers`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "X-MailerLite-ApiKey": config.mailerLiteApiKey
                },
                body: JSON.stringify({ email })
            });

            if (response.ok) {
                toast.success("Subscribed successfully!");
                setEmail("");
            } else {
                const errData = await response.json();
                toast.error(errData?.error?.message || "Subscription failed.");
            }
        } catch (err) {
            console.error("MailerLite error:", err);
            toast.error("An error occurred.");
        }
        setSubscribing(false);
    }
    return (
        <footer className="footer">
            <div className="footer-inner container">
                <div className="footer-brand">
                    <Link to="/" className="footer-logo" style={{ display: "block", marginBottom: 20 }}>
                        {config.siteLogo ? (
                            <img src={config.siteLogo} alt={config.siteName} style={{ maxHeight: 40, filter: "brightness(0) invert(1)" }} />
                        ) : (
                            <span style={{ fontSize: "1.4rem", fontWeight: 800, color: "white" }}>{config.siteName || "LB Books"}</span>
                        )}
                    </Link>
                    <p style={{ whiteSpace: "pre-line" }}>{config.footerDescription}</p>
                </div>

                <div className="footer-links">
                    <h4>Navigate</h4>
                    <Link to="/">Home</Link>
                    <Link to="/shop">Shop</Link>
                    <Link to="/news">News</Link>
                    <Link to="/bookstores">Bookstores</Link>
                    <Link to="/about">About</Link>
                    <Link to="/contact">Contact</Link>
                </div>

                <div className="footer-links">
                    <h4>Categories</h4>
                    {config.categories && config.categories.length > 0 ? (
                        config.categories.slice(0, 5).map(cat => (
                            <Link key={cat} to={`/shop?cat=${encodeURIComponent(cat)}`}>{cat}</Link>
                        ))
                    ) : (
                        <>
                            <Link to="/shop">All Books</Link>
                            <Link to="/shop?cat=Romance">Romance</Link>
                            <Link to="/shop?cat=Digital">Digital</Link>
                        </>
                    )}
                </div>

                <div className="footer-social">
                    <h4 style={{ textTransform: "uppercase" }}>{config.socialTitle || "Follow Liliz Black"}</h4>
                    <div className="social-icons">
                        {config.facebookUrl && (
                            <a href={config.facebookUrl} target="_blank" rel="noreferrer" aria-label="Facebook">
                                <FaFacebook size={22} />
                            </a>
                        )}
                        {config.instagramUrl && (
                            <a href={config.instagramUrl} target="_blank" rel="noreferrer" aria-label="Instagram">
                                <FaInstagram size={22} />
                            </a>
                        )}
                        {config.tiktokUrl && (
                            <a href={config.tiktokUrl} target="_blank" rel="noreferrer" aria-label="TikTok">
                                <FaTiktok size={22} />
                            </a>
                        )}
                        {config.goodreadsUrl && (
                            <a href={config.goodreadsUrl} target="_blank" rel="noreferrer" aria-label="Goodreads">
                                <SiGoodreads size={20} />
                            </a>
                        )}
                    </div>
                    <div className="newsletter">
                        <p>Get updates about new releases</p>
                        <form onSubmit={handleSubscribe}>
                            <input 
                                type="email" 
                                placeholder="Your email address" 
                                value={email}
                                onChange={e => setEmail(e.target.value)}
                                required
                            />
                            <button type="submit" className="btn-primary" disabled={subscribing}>
                                {subscribing ? "..." : "Subscribe"}
                            </button>
                        </form>
                    </div>
                </div>
            </div>

            <div className="footer-bottom">
                <div className="container" style={{ textAlign: "center" }}>
                    <p>
                        {config.footerNote || `© ${new Date().getFullYear()} ${config.siteName || "LB Books"}. All rights reserved.`}
                        <Link to="/admin" style={{ marginLeft: 10, opacity: 0.3, color: "inherit", textDecoration: "none", fontSize: "0.8rem" }}>Admin</Link>
                    </p>
                </div>
            </div>
        </footer>
    );
}